<template>
    <el-container class="chat-container">
      <!-- 左侧客户列表 -->
      <el-aside width="280px" class="client-list">
       
        <div class="operator-bar">
        <el-select 
          v-model="currentAgent"
          placeholder="选择客服身份"
          @change="switchAgent"
          class="agent-select"
          filterable>
          <el-option
            v-for="agent in agents"
            :key="agent.id"
            :label="agent.name"
            :value="agent.id">
            <div class="agent-option">
              <el-avatar :size="24" :src="agent.avatar"></el-avatar>
              <span style="margin-left: 10px">{{ agent.name }}</span>
              <el-tag 
                v-if="agent.status === 'online'"
                size="mini"
                type="success"
                style="margin-left: auto">
                在线
              </el-tag>
            </div>
          </el-option>
        </el-select>
      </div>
       
        <el-menu :default-active="activeClient" class="client-menu">
          <el-menu-item 
            v-for="client in clients" 
            :key="client.id" 
            :index="client.id"
            @click="selectClient(client)"
            class="client-item" style="line-height: 20px;">
            <div class="client-info">
              <el-avatar :size="40" :src="client.avatar" class="client-avatar">
                <img v-if="!client.avatar" src="默认头像路径"/>
              </el-avatar>
              <div class="client-details">
                <div class="client-name">
                  {{ client.name }}
                  <el-tag 
                    v-if="client.status === 'online'" 
                    size="mini" 
                    type="success"
                    effect="dark">
                    在线
                  </el-tag>
                  <el-tag 
                    v-else 
                    size="mini" 
                    type="info"
                    effect="dark">
                    离线
                  </el-tag>
                </div>
                <div class="last-message">{{ client.lastMessage }}</div>
              </div>
              <div class="client-status">
                <div class="time">{{ client.lastTime }}</div>
                <el-badge 
                  v-if="client.unread > 0" 
                  :value="client.unread" 
                  class="unread-badge"/>
              </div>
            </div>
          </el-menu-item>
        </el-menu>
      </el-aside>
  
      <!-- 右侧聊天区域 -->
      <el-main class="chat-main">
        <div v-if="activeClient" class="chat-wrapper">
          <!-- 消息显示区域 -->
          <div ref="messageArea" class="message-area">
            <div 
              v-for="(msg, index) in messages" 
              :key="index"
              :class="['message-item', msg.senderType]">
              <el-avatar 
                :size="36" 
                :src="msg.avatar"
                class="message-avatar"/>
              <div class="message-content">
                <div class="message-bubble">
                  <div class="message-text">{{ msg.content }}</div>
                  <div class="message-time">{{ msg.time }}</div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 消息输入区域 -->
          <div class="input-area">
            <el-input
              v-model="newMessage"
              type="textarea"
              :rows="3"
              resize="none"
              placeholder="输入消息..."
              @keyup.enter.native="sendMessage"
              class="message-input"/>
            <el-button 
              type="primary" 
              @click="sendMessage"
              class="send-button">
              发送 (Enter)
            </el-button>
          </div>
        </div>
  
        <div v-else class="empty-chat">
          <el-empty description="请选择客户开始对话"></el-empty>
        </div>
      </el-main>
    </el-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        activeClient: null,
        newMessage: '',
        currentAgent: 1001, // 当前登录客服ID
      agents: [
        {
          id: 1001,
          name: '客服小明',
          avatar: 'https://example.com/agent1.jpg',
          status: 'online'
        },
        {
          id: 1002,
          name: '客服小红',
          avatar: 'https://example.com/agent2.jpg',
          status: 'busy'
        }
      ],
        clients: [
          {
            id: 1,
            name: '张三',
            avatar: 'https://example.com/avatar1.jpg',
            status: 'online',
            lastMessage: '你好，我想咨询产品问题',
            lastTime: '10:30',
            unread: 2
          },
          {
            id: 2,
            name: '李四',
            avatar: 'https://example.com/avatar2.jpg',
            status: 'offline',
            lastMessage: '订单状态如何？',
            lastTime: '昨天 15:20',
            unread: 0
          }
        ],
        messages: [
          {
            senderType: 'customer',
            content: '你好，我的订单有问题',
            time: '10:30',
            avatar: 'https://example.com/avatar1.jpg'
          },
          {
            senderType: 'service',
            content: '请提供订单号',
            time: '10:31',
            avatar: '客服头像路径'
          }
        ]
      }
    },
    methods: {
         // 新增切换客服方法
      switchAgent(agentId) {
        console.log(`切换到客服ID: ${agentId}`)
        // 这里可以添加：
        // 1. 权限验证
        // 2. 获取新客服的对话列表
        // 3. 更新当前会话状态
      },
      selectClient(client) {
        this.activeClient = client.id
        // 这里可以添加获取历史消息的逻辑
      },
      sendMessage() {
        if (this.newMessage.trim()) {
          this.messages.push({
            senderType: 'service',
            content: this.newMessage,
            time: new Date().toLocaleTimeString(),
            avatar: '客服头像路径'
          })
          this.newMessage = ''
          // 自动滚动到底部
          this.$nextTick(() => {
            this.$refs.messageArea.scrollTop = this.$refs.messageArea.scrollHeight
          })
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .chat-container {
 
    border: 1px solid #ebeef5;
  }
  
  .client-list {
    border-right: 1px solid #ebeef5;
  }
  
  .client-menu {
    border-right: none;
  }
  
  .client-item {
 
    height: 80px;
    padding: 8px 12px;
    line-height: 0px;
    padding-top: 20px;
  }
  
  .client-info {
    display: flex;

    width: 100%;
  }
  
  .client-avatar {
    flex-shrink: 0;
  }
  
  .client-details {
    flex: 1;
    margin-left: 12px;
    min-width: 0;
  }
  
  .client-name {
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .last-message {
    color: #909399;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .client-status {
    text-align: right;
    margin-left: 12px;
  }
  
  .time {
    font-size: 12px;
    color: #c0c4cc;
  }
  
  .unread-badge {
    margin-top: 4px;
  }
  
  .chat-main {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  
  .message-area {
    flex: 1;
    padding: 20px;
    height: 550px;
    overflow-y: auto;
    background-color: #f5f7fa;
  }
  
  .message-item {
    display: flex;
    margin-bottom: 20px;
  }
  
  .message-item.customer {
    flex-direction: row;
  }
  
  .message-item.service {
    flex-direction: row-reverse;
  }
  
  .message-avatar {
    flex-shrink: 0;
  }
  
  .message-content {
    max-width: 70%;
    margin: 0 12px;
  }
  
  .message-bubble {
    padding: 12px;
    border-radius: 4px;
    position: relative;
  }
  
  .message-item.customer .message-bubble {
    background-color: #ffffff;
    border: 1px solid #ebeef5;
  }
  
  .message-item.service .message-bubble {
    background-color: #409eff;
    color: white;
  }
  
  .message-time {
    font-size: 12px;
    color: #c0c4cc;
    margin-top: 4px;
  }
  
  .message-item.service .message-time {
    color: rgba(255, 255, 255, 0.8);
  }
  
  .input-area {
    border-top: 1px solid #ebeef5;
    padding: 16px;
    display: flex;
    gap: 12px;
  }
  
  .message-input {
    flex: 1;
  }
  
  .send-button {
    align-self: flex-end;
    height: 72px;
  }
  
  .empty-chat {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 新增样式 */
.operator-bar {
  padding: 12px;
  border-bottom: 1px solid #ebeef5;
  background: #f5f7fa;
}

.agent-select {
  width: 100%;
}

.agent-option {
  display: flex;
  align-items: center;


}
  </style>
  


// WEBPACK FOOTER //
// src/views/service/index.vue